import React, { Fragment } from 'react';
import { Container, Button } from 'react-bootstrap';
import Header from '../../components/header';
import Head from '../../components/head';
import Footer from '../../components/footer';
import ItemBox from '../../components/shared/item_box';
import { Link } from 'react-router-dom';


function LrfScreen() {
    return (
        <Fragment>
            <Head titulo="Relatórios Contábeis - Lei de Responsabilidade Fiscal" />
            <Header />
            <Container>
                <ItemBox
                    titulo={"Relatório Resumido da Execução Orçamentária (RREO)"}
                    texto={[<Fragment>O Relatório Resumido da Execução Orçamentária (RREO) é um relatório exigido pela Constituição Federal de 1988 e tem a sua estrutura definida pela Lei de Responsabilidade Fiscal (LRF), compreendendo demonstrativos como o Balanço Orçamentário, Despesas Orçamentárias por Função e Subfunção, Receita Corrente Líquida, Resultados dos Regimes Próprio e Geral de Previdência Social (RPPS e RGPS), Resultados Primário e Nominal, Cumprimento dos Mínimos Constitucionais com Saúde e Educação e Execução dos Restos a Pagar inscritos no exercício anterior. Além disso, no primeiro bimestre do exercício, o RREO inclui também o Demonstrativo do Superávit Financeiro apurado no Balanço Patrimonial por destinação de recursos, que fundamenta a abertura de créditos adicionais<br/><br/>.</Fragment>]}
                    link={"lrf/rreo"}
                />
                <ItemBox
                    titulo={"Relatório de Gestão Fiscal (RGF)"}
                    texto={[<Fragment>O Relatório de Gestão Fiscal (RGF) é um dos instrumentos de transparência da gestão fiscal que foram criados pela LRF. Especificamente, o RGF objetiva o controle, o monitoramento e a publicidade do cumprimento, por parte dos entes federativos, dos limites estabelecidos pela LRF: Despesas com Pessoal, Dívida Consolidada Líquida, Concessão de Garantias e Contratação de Operações de Crédito.<br /><br /></Fragment>]}
                    link={"lrf/rgf"}
                />
                <ItemBox
                    titulo={"Demonstrativo Consolidado do Relatório de Gestão Fiscal (DCRGF)"}
                    texto={[<Fragment> O Demonstrativo Consolidado do Relatório de Gestão Fiscal (RGF) é um dos instrumentos de transparência da gestão fiscal que foram criados pela LRF. Especificamente, o DCRGF objetiva o controle, o monitoramento e a publicidade do cumprimento, por parte dos entes federativos, dos limites estabelecidos pela LRF: Despesas com Pessoal, Dívida Consolidada Líquida, Concessão de Garantias e Contratação de Operações de Crédito.
                        <br /><br /></Fragment>]}
                    link={"lrf/dcrgf"}
                />
                <ItemBox
                    titulo={"Prestação de Contas"}
                    texto={[<Fragment>A prestação de contas anual é um procedimento pelo qual o responsável por órgãos e entidades municipais apresenta documentos, informações e demonstrativos de natureza contábil, financeira, orçamentária, operacional e patrimonial destinado a comprovar, perante o Tribunal, a regularidade da gestão dos recursos públicos durante o exercício financeiro.
                        <br /><br /></Fragment>]}
                    link={"contas"}
                />
                <Link to={"/"}>
                    <Button variant='danger' type='button'>Voltar</Button>
                </Link>
            </Container>
            <Footer />
        </Fragment>
    );
}

export default LrfScreen;